export default {
	read_only_badge: 'Read-only'
};
